import React from "react";
import { ReportLayout } from "../../../components/ReportLayout/ReportLayout";
import { ButtonScrollTop } from "../../../../../shared/ButtonScrollTop/ButtonScrollTop";
import { StickyBox } from "../../../../../shared/StickyBox/StickyBox";
import { useReport } from "./hooks/useReport";
import { useDownloadExcel } from "./hooks/useDownloadExcel";
import { Header } from "./shared/Header";
import { Table } from "./shared/Table";

export function ShopifyProductSalesReport() {
  var { reports, period, search, order } = useReport();
  var downloadExcel = useDownloadExcel({ period, search, order });

  return (
    <ReportLayout>
      <Header
        period={period}
        search={search}
        isReportsLoading={reports.isLoading}
        downloadExcel={downloadExcel}
      />
      <Table reports={reports} order={order} />
      <StickyBox position="left" visibleAfterOffset={300}>
        <ButtonScrollTop />
      </StickyBox>
    </ReportLayout>
  );
}
